import { render, staticRenderFns } from "./ControllerAddItem.vue?vue&type=template&id=57a6900f&"
import script from "./ControllerAddItem.vue?vue&type=script&lang=js&"
export * from "./ControllerAddItem.vue?vue&type=script&lang=js&"
import style0 from "./ControllerAddItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports